import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import { FrequencyValue } from '@kaizenplatform/kaizen-chartjs';

export const setCoverageReportFrequency = (coverageReportFrequency: FrequencyValue) =>
  produce((draft: Draft<State>) => {
    draft.coverageReportFrequency.data = coverageReportFrequency;
  });

export const disposeCoverageReportFrequency = () =>
  produce((draft: Draft<State>) => {
    draft.coverageReportFrequency.data = initialState.coverageReportFrequency.data;
  });
